document.addEventListener('DOMContentLoaded', function () {
    if (
        window.location.pathname === '/cart' ||
        window.location.pathname === '/pages/final-review'
    ) return;
  let pendingFormId = null;
  let pendingPdpForm = null;
  let pendingSource = null;
  let supplovinGuideTimer = null;
  const productDataCache = {};

function allowedPackTagFound(product) {
  if (!product) return false;

  const allowedKeywords = [
    'tablet',
    'tablets',
    'capsule',
    'capsules',
    'softgel',
    'softgels',
    'soft gel',
    'soft gels',
    'gummy',
    'gummies',
    'chewable',
    'chewables',
    'soft chew',
    'soft chews'
  ];

  const tagsText = Array.isArray(product.tags)
    ? product.tags.join(' ')
    : String(product.tags || '');

  const searchableText = [
    product.title || '',
    tagsText,
    product.product_type || ''
  ]
    .join(' ')
    .toLowerCase();

  return allowedKeywords.some(function (word) {
    return searchableText.includes(word);
  });
}


  function showBlockedPackMessage() {
  let modal = document.getElementById('blocked-pack-modal');

  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'blocked-pack-modal';
    modal.className = 'blocked-pack-modal hidden';
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="blocked-pack-modal__overlay"></div>

      <div class="blocked-pack-modal__panel" role="dialog" aria-modal="true">
        <button type="button" class="blocked-pack-modal__close" aria-label="Close">×</button>

        <h2 class="blocked-pack-modal__title">
          This item can’t be added to your pack
        </h2>

        <p class="blocked-pack-modal__message">
          We’re currently unable to include this item in your pack. Please select a similar product available in tablet, capsule, softgel, gummy, chewable, or soft chew form.
        </p>

        <button type="button" class="blocked-pack-modal__button">
          Got it
        </button>
      </div>
    `;

    document.body.appendChild(modal);

    modal
      .querySelector('.blocked-pack-modal__close')
      .addEventListener('click', closeBlockedPackModal);

    modal
      .querySelector('.blocked-pack-modal__button')
      .addEventListener('click', closeBlockedPackModal);

    modal
      .querySelector('.blocked-pack-modal__overlay')
      .addEventListener('click', closeBlockedPackModal);
  }

  modal.classList.remove('hidden');
  modal.setAttribute('aria-hidden', 'false');
}

function closeBlockedPackModal() {
  const modal = document.getElementById('blocked-pack-modal');

  if (!modal) return;

  modal.classList.add('hidden');
  modal.setAttribute('aria-hidden', 'true');
}

  let originalPackagingConfirmAction = null;

  function showOriginalPackagingMessage(onConfirm) {
    let modal = document.getElementById('original-packaging-modal');

    originalPackagingConfirmAction =
      typeof onConfirm === 'function' ? onConfirm : null;

    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'original-packaging-modal';
      modal.className = 'blocked-pack-modal hidden';
      modal.setAttribute('aria-hidden', 'true');

      modal.innerHTML = `
        <div class="blocked-pack-modal__overlay"></div>

        <div class="blocked-pack-modal__panel" role="dialog" aria-modal="true" aria-labelledby="original-packaging-title">
          <button type="button" class="blocked-pack-modal__close" aria-label="Close">×</button>

          <h2 class="blocked-pack-modal__title" id="original-packaging-title">
            This product will ship in its original packaging
          </h2>

          <p class="blocked-pack-modal__message">
            This product cannot be placed inside your individual daily pouches because of its form. It will be shipped together with your Daily Pack order in the manufacturer’s original packaging.
          </p>

          <div style="display:flex; gap:10px; justify-content:center; flex-wrap:wrap;">
            <button type="button" class="blocked-pack-modal__button original-packaging-cancel" style="background:#eef5f4; color:#255e59;">
              Cancel
            </button>

            <button type="button" class="blocked-pack-modal__button original-packaging-confirm">
              Add to cart
            </button>
          </div>
        </div>
      `;

      document.body.appendChild(modal);

      modal
        .querySelector('.blocked-pack-modal__close')
        .addEventListener('click', closeOriginalPackagingModal);

      modal
        .querySelector('.original-packaging-cancel')
        .addEventListener('click', closeOriginalPackagingModal);

      modal
        .querySelector('.blocked-pack-modal__overlay')
        .addEventListener('click', closeOriginalPackagingModal);

      modal
        .querySelector('.original-packaging-confirm')
        .addEventListener('click', function () {
          const action = originalPackagingConfirmAction;
          closeOriginalPackagingModal();

          if (typeof action === 'function') {
            action();
          }
        });
    }

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeOriginalPackagingModal() {
    const modal = document.getElementById('original-packaging-modal');

    if (!modal) return;

    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    originalPackagingConfirmAction = null;
  }

  function getHandleFromUrl(url) {
    if (!url) return '';

    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function getProductHandleFromCard(card) {
    if (!card) return '';

    const productLink = card.querySelector('a[href*="/products/"]');
    return productLink ? getHandleFromUrl(productLink.getAttribute('href')) : '';
  }

  function getPdpProductHandle() {
    return getHandleFromUrl(window.location.pathname);
  }

  function fetchProductDataByHandle(handle) {
    if (!handle) return Promise.resolve(null);

    if (productDataCache[handle]) {
      return Promise.resolve(productDataCache[handle]);
    }

    return fetch('/products/' + handle + '.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (product) {
        productDataCache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  }
async function getPackProductTypeByHandle(handle) {
  const product = await fetchProductDataByHandle(handle);

  if (!product) {
    return 'original-packaging';
  }

  if (allowedPackTagFound(product)) {
    return 'packable';
  }

  return 'original-packaging';
}

function hideMembershipProduct() {
  const hiddenMembershipNames = [
    'supplovin monthly membership',
    'supplovin monthly additional family membership',
    'supplovin 30-day free membership'
  ];

  document
    .querySelectorAll(
      '.custom-search-suggestion-item, ' +
      '#algolia-shopify-instantsearch .ais-hit, ' +
      '#algolia-shopify-instantsearch .ais-hits--item, ' +
      '#algolia-shopify-instantsearch .ais-Hits-item'
    )
    .forEach(function (item) {
      const text = (item.textContent || '').trim().toLowerCase();

      const isMembershipProduct = hiddenMembershipNames.some(function (name) {
        return text.includes(name);
      });

      if (isMembershipProduct) {
        item.style.setProperty('display', 'none', 'important');
        item.setAttribute('aria-hidden', 'true');
      }
    });
}
  function relabelButtons() {
    const algoliaButtons = document.querySelectorAll(
      '#algolia-shopify-instantsearch .ais-hit--cart-button'
    );

    algoliaButtons.forEach(function (btn) {
      if (btn.textContent.trim() !== 'Add to Pack') {
        btn.textContent = 'Add to Pack';
      }
    });

    const pdpButtons = document.querySelectorAll(
      'product-form form button[type="submit"], form[action*="/cart/add"] button[type="submit"], button[name="add"]'
    );

    pdpButtons.forEach(function (btn) {
      const text = btn.textContent.trim().toLowerCase();

      if (text.includes('add to cart') || text === 'add to pack') {
        btn.textContent = 'Add to Pack';
      }
    });
  }

  function relabelSearchHeading() {
    if (!hasAlgoliaSearch()) return;

    const headings = document.querySelectorAll('#algolia-shopify-instantsearch .ais-page .ais-h2');

    headings.forEach(function (heading) {
      const text = heading.textContent.trim().toLowerCase();

      if (
        text === 'search result' ||
        text === 'search results' ||
        text === 'build your daily pack'
      ) {
        heading.textContent = '';
      }
    });
  }

  function isLikelyRawProductCode(text) {
    const cleaned = text.trim();

    if (!cleaned) return false;
    if (cleaned.length < 8 || cleaned.length > 18) return false;
    if (cleaned.includes('$')) return false;
    if (cleaned.includes(' ')) return false;
    if (!/[0-9]/.test(cleaned)) return false;

    return /^[A-Z0-9_-]+$/.test(cleaned);
  }

  function hideRawProductCodeLines() {
    if (!hasAlgoliaSearch()) return;

    const cards = document.querySelectorAll(
      '#algolia-shopify-instantsearch .ais-hit, #algolia-shopify-instantsearch .ais-hits--item, #algolia-shopify-instantsearch .ais-Hits-item'
    );

    cards.forEach(function (card) {
      const elements = card.querySelectorAll('p, span, small, div');

      elements.forEach(function (el) {
        if (
          el.closest('button') ||
          el.closest('a') ||
          el.classList.contains('ais-hit--title') ||
          el.classList.contains('ais-hit--price') ||
          el.classList.contains('ais-hit--cart-button')
        ) {
          return;
        }

        const text = el.textContent.trim();

        if (isLikelyRawProductCode(text)) {
          el.style.display = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });
    });
  }

function cleanSubtitles() {
  const subtitles = document.querySelectorAll(
    '#algolia-shopify-instantsearch .ais-hit--subtitle'
  );

  subtitles.forEach(function (el) {
    const text = el.textContent;

    if (text.includes(' by ')) {
      const brand = text.split(' by ')[1];

      if (brand) {
        el.textContent = 'by ' + brand.trim();
      }
    }
  });
}

function refreshAlgoliaUi() {
  relabelButtons();
  hideMembershipProduct();
  relabelSearchHeading();
  hideRawProductCodeLines();
  cleanSubtitles();
}

  function getProductCardFromButton(btn) {
    return btn.closest('.ais-hits--item, .ais-Hits-item, .ais-hit');
  }

  function getProductName(card) {
    if (!card) return '';

    const candidates = card.querySelectorAll('h1, h2, h3, h4, a, .ais-hit--title');

    for (const el of candidates) {
      const text = el.textContent.trim();

      if (text && text.toLowerCase() !== 'add to pack') {
        return text;
      }
    }

    return '';
  }

  function getProductImage(card) {
    if (!card) return '';

    const img = card.querySelector('img');
    return img ? img.src : '';
  }

  function getPdpProductName() {
    const selectors = [
      'h1.product__title',
      '.product__title h1',
      'main h1',
      'h1'
    ];

    for (const sel of selectors) {
      const el = document.querySelector(sel);

      if (el && el.textContent.trim()) {
        return el.textContent.trim();
      }
    }

    return '';
  }

  function getPdpProductImage() {
    const selectors = [
      '.product__media img',
      '.product-media-container img',
      '.product img'
    ];

    for (const sel of selectors) {
      const img = document.querySelector(sel);

      if (img && img.src) {
        return img.src;
      }
    }

    return '';
  }

  function getSearchSection() {
    return document.querySelector('#algolia-shopify-instantsearch');
  }

  function getSearchInput() {
  return (
    document.querySelector('header input[type="search"]') ||
    document.querySelector('.header input[type="search"]') ||
    document.querySelector('#Search-In-Modal') ||
    document.querySelector('#algolia-shopify-instantsearch .ais-SearchBox-input') ||
    document.querySelector('#algolia-shopify-instantsearch input[type="search"]')
  );
}

  function closeCartDrawerIfOpen() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
      return;
    }

    const closeButton =
      document.querySelector('cart-drawer .drawer__close') ||
      document.querySelector('.drawer__close') ||
      document.querySelector('[aria-label="Close"]');

    if (closeButton) {
      closeButton.click();
    }
  }

  function scrollSearchNearTop() {
    const searchSection = getSearchSection();

    if (!searchSection) return;

    const rect = searchSection.getBoundingClientRect();
    const absoluteTop = rect.top + window.pageYOffset;
    const offsetFromTop = 110;
    const targetTop = absoluteTop - offsetFromTop;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  }

  function focusSearchInput() {
    const input = getSearchInput();

    if (!input) return;

    input.focus();
    input.click();
  }

  function scrollSearchNearTopAndFocus() {
    scrollSearchNearTop();

    setTimeout(focusSearchInput, 250);
    setTimeout(focusSearchInput, 650);
  }

  function goToSearchFromAnywhere() {
    closeCartDrawerIfOpen();

    const searchSection = getSearchSection();

    if (!searchSection) {
      sessionStorage.setItem('supplovin_scroll_to_search', '1');
      window.location.href = '/?supplovin_search=1#build-pack';
      return;
    }

    scrollSearchNearTopAndFocus();

    setTimeout(scrollSearchNearTopAndFocus, 350);
    setTimeout(scrollSearchNearTopAndFocus, 850);
  }

  function maybeScrollToSearchAfterLoad() {
    const shouldScroll =
      sessionStorage.getItem('supplovin_scroll_to_search') === '1' ||
      window.location.hash === '#build-pack' ||
      window.location.search.includes('supplovin_search=1');
    if (!shouldScroll) return;

    sessionStorage.removeItem('supplovin_scroll_to_search');

    setTimeout(scrollSearchNearTopAndFocus, 450);
    setTimeout(scrollSearchNearTopAndFocus, 950);
    setTimeout(scrollSearchNearTopAndFocus, 1600);
  }

  function enableSearchFocusMode() {
    if (window.innerWidth > 749) return;

    document.body.classList.add('supplovin-search-focused');
  }

  function disableSearchFocusMode() {
    document.body.classList.remove('supplovin-search-focused');
  }

  function resetModalOptions() {
    const customizeArea = document.getElementById('pack-customize-area');
    const qty = document.getElementById('pack-quantity');
    const panel = document.querySelector('.pack-modal__panel');

    if (customizeArea) customizeArea.classList.add('hidden');
    if (qty) qty.value = '';
    if (panel) panel.classList.remove('is-expanded');
  }

  function populateModal(name, image) {
    const nameEl = document.getElementById('pack-modal-product-name');
    const imageEl = document.getElementById('pack-modal-image');

    if (nameEl) {
      nameEl.textContent = name || '';
    }

    if (imageEl) {
      imageEl.src = image || '';
      imageEl.alt = name || 'Product image';
    }
  }
function updatePackDropdown() {
  const select = document.getElementById('pack-choice');
  if (!select) return;

  const packs = getPackOptions();

  select.innerHTML = '';

  packs.forEach(function (pack) {
    const option = document.createElement('option');
    option.value = pack.value;
    option.textContent = pack.label;
    select.appendChild(option);
  });
}
  function openModalForAlgolia(btn) {
    pendingSource = 'algolia';
    pendingPdpForm = null;
    pendingFormId = btn.getAttribute('data-form-id') || null;

    const card = getProductCardFromButton(btn);

    populateModal(getProductName(card), getProductImage(card));
    resetModalOptions();
    updatePackDropdown();
    const modal = document.getElementById('pack-modal');

    if (!modal) return;

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
  }

  function openModalForPdp(form) {
    pendingSource = 'pdp';
    pendingFormId = null;
    pendingPdpForm = form;

    populateModal(getPdpProductName(), getPdpProductImage());
    resetModalOptions();
    updatePackDropdown();
    const modal = document.getElementById('pack-modal');

    if (!modal) return;

    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeModal() {
    const modal = document.getElementById('pack-modal');

    if (!modal) return;

    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
  }
function getPackOptions() {
  const customer = window.supplovinCustomer || {};
  const totalPacks = parseInt(customer.totalPacks || 1, 10);
  const packNamesRaw = customer.packNames || '';

  const names = {};

  packNamesRaw.split('\n').forEach(function (line) {
    const parts = line.split('|');
    if (parts.length === 2) {
      names[parts[0].trim()] = parts[1].trim();
    }
  });

  const packs = [];

  for (let i = 1; i <= totalPacks; i++) {
    const key = 'Pack ' + i;
    packs.push({
      value: key,
      label: names[key] || key
    });
  }

  return packs;
}
  function setFormProperties(form, mode, quantity) {
    if (!form) return;

    form.querySelectorAll(
      '[name="properties[Pack Quantity Mode]"], [name="properties[Pack Quantity]"]'
    ).forEach(function (el) {
      el.remove();
    });

    const modeInput = document.createElement('input');
    modeInput.type = 'hidden';
    modeInput.name = 'properties[Selected Pack]';
    modeInput.value = mode;
    form.appendChild(modeInput);

    if (quantity) {
      const qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'properties[Pack Quantity]';
      qtyInput.value = quantity;
      form.appendChild(qtyInput);
    }
  }

  function setOriginalPackagingProperties(form) {
    if (!form) return;

    form.querySelectorAll(
      '[name="properties[Selected Pack]"], ' +
      '[name="properties[Pack Quantity Mode]"], ' +
      '[name="properties[Pack Quantity]"], ' +
      '[name="properties[Packaging]"], ' +
      '[name="properties[Daily Pouch Status]"]'
    ).forEach(function (el) {
      el.remove();
    });

    const packagingInput = document.createElement('input');
    packagingInput.type = 'hidden';
    packagingInput.name = 'properties[Packaging]';
    packagingInput.value = 'Ships in manufacturer original packaging';
    form.appendChild(packagingInput);

    const pouchStatusInput = document.createElement('input');
    pouchStatusInput.type = 'hidden';
    pouchStatusInput.name = 'properties[Daily Pouch Status]';
    pouchStatusInput.value = 'Not included in individual daily pouches';
    form.appendChild(pouchStatusInput);
  }
  function showCartToast(message) {
  let toast = document.getElementById('supplovin-cart-toast');

  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'supplovin-cart-toast';
    toast.textContent = message;
    document.body.appendChild(toast);
  }

  toast.textContent = message;
  toast.classList.add('show');

  setTimeout(function () {
    toast.classList.remove('show');
  }, 2500);
}
  async function ajaxAddToCart(form) {
  const formData = new FormData(form);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      form.submit();
      return;
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    showCartToast('Added to cart');
  } catch (error) {
    form.submit();
  }
}
  function submitPending(mode, quantity) {
    if (pendingSource === 'algolia' && pendingFormId) {
      const form = document.getElementById(pendingFormId);

      if (!form) return;

      setFormProperties(form, mode, quantity);
      closeModal();
      ajaxAddToCart(form);
      return;
    }

    if (pendingSource === 'pdp' && pendingPdpForm) {
      setFormProperties(pendingPdpForm, mode, quantity);
      closeModal();
      ajaxAddToCart(pendingPdpForm);
    }
  }

  function ensureSearchGuide() {
    if (document.getElementById('supplovin-search-guide')) return;

    const guide = document.createElement('div');
    guide.id = 'supplovin-search-guide';
    guide.className = 'supplovin-search-guide';
    guide.setAttribute('aria-hidden', 'true');

    guide.innerHTML = `
      <div class="supplovin-search-guide__scrim"></div>
      <div class="supplovin-search-guide__content">
        <div class="supplovin-search-guide__text" id="supplovin-search-guide-text"></div>
        <div class="supplovin-search-guide__arrow"></div>
        <div class="supplovin-search-guide__button-wrap">
          <button type="button" class="supplovin-search-guide__button" id="supplovin-search-guide-button">Let's go</button>
        </div>
      </div>
    `;

    document.body.appendChild(guide);
  }

  function typeGuideText() {
    const guide = document.getElementById('supplovin-search-guide');
    const textEl = document.getElementById('supplovin-search-guide-text');

    if (!guide || !textEl) return;

    const phrase = 'Start typing favorite brands and products';
    let i = 0;

    textEl.textContent = '';
    guide.classList.remove('is-ready');

    if (supplovinGuideTimer) {
      clearInterval(supplovinGuideTimer);
      supplovinGuideTimer = null;
    }

    supplovinGuideTimer = setInterval(function () {
      i += 1;
      textEl.textContent = phrase.slice(0, i);

      if (i >= phrase.length) {
        clearInterval(supplovinGuideTimer);
        supplovinGuideTimer = null;
        guide.classList.add('is-ready');
      }
    }, 28);
  }

  function openSearchGuide() {
    if (sessionStorage.getItem('supplovin_search_guide_seen') === '1') return;

    ensureSearchGuide();

    const guide = document.getElementById('supplovin-search-guide');

    if (guide) {
      guide.setAttribute('aria-hidden', 'false');
    }

    document.body.classList.add('supplovin-guide-open');
    typeGuideText();
  }

  function closeSearchGuide() {
    const guide = document.getElementById('supplovin-search-guide');

    document.body.classList.remove('supplovin-guide-open');

    if (guide) {
      guide.classList.remove('is-ready');
      guide.setAttribute('aria-hidden', 'true');
    }

    sessionStorage.setItem('supplovin_search_guide_seen', '1');

    if (supplovinGuideTimer) {
      clearInterval(supplovinGuideTimer);
      supplovinGuideTimer = null;
    }
  }

  function closeGuideAndFocusSearch() {
    closeSearchGuide();

    setTimeout(scrollSearchNearTopAndFocus, 50);
    setTimeout(scrollSearchNearTopAndFocus, 400);
    setTimeout(scrollSearchNearTopAndFocus, 900);
  }

  function initHeroVideoReveal() {
    const heroInner = document.querySelector('.daily-pack-hero__inner');

    if (!heroInner) return;

    window.setTimeout(function () {
      heroInner.classList.add('is-ready');
    }, 200);
  }

  function initHeroButtonFlow() {
    if (!document.querySelector('.daily-pack-hero__button')) return;

    document.addEventListener(
      'click',
      function (e) {
        const heroButton = e.target.closest('.daily-pack-hero__button');

        if (!heroButton) return;

        const href = heroButton.getAttribute('href');

        if (href !== '#build-pack') return;

        e.preventDefault();

        scrollSearchNearTop();

        setTimeout(scrollSearchNearTop, 250);
        setTimeout(scrollSearchNearTop, 650);

        setTimeout(function () {
          openSearchGuide();
        }, 700);
      },
      true
    );
  }

  function ensurePackBar() {
    if (document.getElementById('supplovin-pack-bar')) return;

    const bar = document.createElement('div');
    bar.id = 'supplovin-pack-bar';
    bar.className = 'supplovin-pack-bar';
    bar.setAttribute('aria-hidden', 'true');

    bar.innerHTML = `
      <div class="supplovin-pack-bar__inner">
        <div class="supplovin-pack-bar__text">
          <div class="supplovin-pack-bar__title">Your Daily Pack</div>
          <div class="supplovin-pack-bar__count" id="supplovin-pack-bar-count">0 items added</div>
        </div>
        <div class="supplovin-pack-bar__actions">
          <button type="button" class="supplovin-pack-bar__button supplovin-pack-bar__button--primary" id="supplovin-pack-view">
            Checkout
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(bar);
  }

  function openCartForPackBar() {
  window.location.href = '/cart?view=default';
}
  function setPackBarCount(itemCount) {
    ensurePackBar();

    const bar = document.getElementById('supplovin-pack-bar');
    const count = document.getElementById('supplovin-pack-bar-count');

    if (!bar || !count) return;

    if (itemCount > 0) {
      count.textContent = itemCount === 1 ? '1 item added' : itemCount + ' items added';
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  function refreshPackBar() {
    fetch('/cart.js', {
      credentials: 'same-origin'
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setPackBarCount(cart.item_count || 0);
      })
      .catch(function () {});
  }

  document.addEventListener(
    'click',
    async function (e) {
      const btn = e.target.closest('#algolia-shopify-instantsearch .ais-hit--cart-button');

      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const card = getProductCardFromButton(btn);
      const handle = getProductHandleFromCard(card);
      const productType = await getPackProductTypeByHandle(handle);

      if (productType === 'original-packaging') {
        const formId = btn.getAttribute('data-form-id') || null;
        const form = formId ? document.getElementById(formId) : null;

        if (!form) return false;

        showOriginalPackagingMessage(function () {
          setOriginalPackagingProperties(form);
          ajaxAddToCart(form);
          setTimeout(refreshPackBar, 900);
        });

        return false;
      }

      openModalForAlgolia(btn);
      return false;
    },
    true
  );

  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;

      if (!form.matches('product-form form, form[action*="/cart/add"]')) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const handle = getPdpProductHandle();
      const productType = await getPackProductTypeByHandle(handle);

      if (productType === 'original-packaging') {
        showOriginalPackagingMessage(function () {
          setOriginalPackagingProperties(form);
          ajaxAddToCart(form);
          setTimeout(refreshPackBar, 900);
        });

        return false;
      }

      openModalForPdp(form);
      return false;
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.pack-modal__close') ||
      e.target.classList.contains('pack-modal__overlay')
    ) {
      closeModal();
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      const guideButton = e.target.closest('#supplovin-search-guide-button');

      if (guideButton) {
        e.preventDefault();
        closeGuideAndFocusSearch();
        return;
      }

      if (!document.body.classList.contains('supplovin-guide-open')) return;

      const clickedSearchArea =
        e.target === getSearchInput() ||
        e.target.closest('#algolia-shopify-instantsearch');

      const clickedScrim = e.target.closest('.supplovin-search-guide__scrim');

      if (clickedSearchArea || clickedScrim) {
        e.preventDefault();
        closeGuideAndFocusSearch();
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      const input = getSearchInput();

      if (input && e.target === input) {
        if (document.body.classList.contains('supplovin-guide-open')) {
          closeSearchGuide();
        }

        enableSearchFocusMode();
      }
    },
    true
  );

  document.addEventListener(
    'focusout',
    function (e) {
      const input = getSearchInput();

      if (input && e.target === input) {
        setTimeout(disableSearchFocusMode, 200);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('#algolia-shopify-instantsearch .ais-SearchBox-reset')) {
        setTimeout(disableSearchFocusMode, 150);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const keepBuildingButton = e.target.closest('#supplovin-pack-keep-building');

      if (!keepBuildingButton) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      goToSearchFromAnywhere();

      return false;
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const viewPackButton = e.target.closest('#supplovin-pack-view');

      if (!viewPackButton) return;

      e.preventDefault();

      openCartForPackBar();
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('#algolia-shopify-instantsearch .ais-hit--cart-button') ||
      e.target.closest('#pack-use-recommended') ||
      e.target.closest('#confirm-pack-add') ||
      e.target.closest('button[name="add"]')
    ) {
      setTimeout(refreshPackBar, 900);
      setTimeout(refreshPackBar, 1800);
      setTimeout(refreshPackBar, 3000);
    }
  });

  const customizeBtn = document.getElementById('pack-customize');

  if (customizeBtn) {
    customizeBtn.addEventListener('click', function () {
      const customizeArea = document.getElementById('pack-customize-area');
      const panel = document.querySelector('.pack-modal__panel');

      if (customizeArea) customizeArea.classList.remove('hidden');
      if (panel) panel.classList.add('is-expanded');
    });
  }

  const recommendedBtn = document.getElementById('pack-use-recommended');

  if (recommendedBtn) {
    recommendedBtn.addEventListener('click', function () {
      submitPending('Pack 1', '');
    });
  }

  const confirmBtn = document.getElementById('confirm-pack-add');

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      const qty = document.getElementById('pack-quantity')?.value || '';
      const pack = document.getElementById('pack-choice')?.value || 'Pack 1';

      if (!qty) {
        alert('Please select a quantity.');
        return;
      }

      submitPending(pack, qty);
    });
  }

  window.addEventListener('pageshow', function () {
    refreshPackBar();
    maybeScrollToSearchAfterLoad();
  });

  function initAlgoliaObserver() {
    const target = document.querySelector('#algolia-shopify-instantsearch');

    if (!target) return;

    const observer = new MutationObserver(function () {
setTimeout(refreshAlgoliaUi, 100);
setTimeout(refreshAlgoliaUi, 500);
setTimeout(refreshAlgoliaUi, 1000);
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  initHeroVideoReveal();
  initHeroButtonFlow();
  initAlgoliaObserver();
  ensurePackBar();
  refreshPackBar();
  maybeScrollToSearchAfterLoad();

  relabelButtons();

  if (hasAlgoliaSearch()) {
    refreshAlgoliaUi();
    setTimeout(refreshAlgoliaUi, 500);
    setTimeout(refreshAlgoliaUi, 1500);
    setTimeout(refreshAlgoliaUi, 3000);
  }
});